// types
import { IEfficiency } from './types'

// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { EfficiencyChart } from '../../components/EfficiencyChart'
import { AiOutlinePercentage } from 'react-icons/ai';
import { useStyletron } from 'baseui';



export function OverviewPanel(props: IEfficiency) {
    const [css, theme] = useStyletron();
    
    return (
        <OverviewPanelWrapper icon={<AiOutlinePercentage size={'100%'} color={theme.colors.backgroundPrimary}></AiOutlinePercentage>} small {...props}>
            <EfficiencyChart resourceGroupId={props.resourceGroupId} id={props.id} value={props.efficiency} stepped={false} showAverage></EfficiencyChart>
        </OverviewPanelWrapper>
    );
}